import React from "react";

const CancellationAndRefund = () => (
  <div className="min-h-screen bg-black text-white flex flex-col items-center py-12 px-4">
    <div className="w-full max-w-2xl mx-auto">
      <h1 className="text-4xl font-semibold font-primary text-center mb-8">
        Cancellation & Refund Policy
      </h1>
      <p className="mb-8 text-lg leading-relaxed">
        At FOZZIL, we aim to provide seamless access to our AI-driven products
        and services including FOZZIL Intelligence and ZYPHER AI. We believe in
        flexibility and transparency when it comes to your subscription or
        purchase decisions.
      </p>
      <h2 className="text-2xl font-bold mb-3 mt-10">Refunds</h2>
      <p className="mb-8 text-lg leading-relaxed">
        We do not offer refunds for any payments already made. All purchases,
        including subscriptions and digital products, are non-refundable. We
        encourage users to explore our product features and documentation before
        purchasing or subscribing. If you experience issues or require
        assistance, our support team is always available to help resolve them.
      </p>
      <h2 className="text-2xl font-bold mb-3 mt-10">Cancellations</h2>
      <p className="mb-4 text-lg leading-relaxed">
        You may cancel your subscription or service at any time.
      </p>
      <ul className="mb-8 text-lg list-disc list-inside space-y-1">
        <li>
          Once canceled, your access to premium features will continue until the
          end of your current billing cycle.
        </li>
        <li>You will not be charged again unless you re-subscribe.</li>
        <li>
          Cancellation is instant, and no further payments will be collected.
        </li>
        <li>
          To cancel, go to your Account Settings or contact us at{" "}
          <a
            href="mailto:support@fozzil.in"
            className="underline hover:text-blue-400"
          >
            support@fozzil.in
          </a>{" "}
          with your registered email ID and Order/Subscription reference.
        </li>
      </ul>
      <h2 className="text-2xl font-bold mb-3 mt-10">Contact</h2>
      <p className="mb-2 text-lg">
        For questions or concerns regarding cancellations or refunds, please
        contact:
        <br />
        <span className="block mt-2">
          📩{" "}
          <a
            href="mailto:legal@fozzil.in"
            className="underline hover:text-blue-400"
          >
            legal@fozzil.in
          </a>
        </span>
      </p>
    </div>
  </div>
);

export default CancellationAndRefund;
